import axiosInstance from './axiosInstance';

/**
 * 分类API响应接口
 */
export interface CategoryResponse {
  category: string;
}

/**
 * 分类列表响应接口
 */
export interface CategoryListResponse {
  categoryList: string[];
}

/**
 * 分类API类，处理游戏分类相关的接口请求
 */
export class CategoryApi {
  /**
   * 获取所有分类
   * @param includeOrder 是否包含排序信息
   * @returns 分类名称数组或包含排序信息的对象数组
   */
  static async getCategories(includeOrder: boolean = false): Promise<string[] | Array<{name: string, order: number}>> {
    const response = await axiosInstance.get<{ data: CategoryListResponse }>(`/cms/v1/category${includeOrder ? '?include_order=true' : ''}`);
    return response.data.data.categoryList;
  }
  
  /**
   * 更新分类排序
   * @param categoryOrders 分类排序数组，格式: [{name: 'Category1', order: 1}, ...]
   * @returns 更新后的分类列表
   */
  static async updateCategoryOrder(categoryOrders: Array<{name: string, order: number}>): Promise<Array<{name: string, order: number}>> {
    const response = await axiosInstance.put<{ data: { categoryList: Array<{name: string, order: number}> } }>('/cms/v1/category', {
      categoryOrders: categoryOrders
    });
    return response.data.data.categoryList;
  }

  /**
   * 添加分类
   * @param name 分类名称
   * @returns 添加的分类名称
   */
  static async addCategory(name: string): Promise<string> {
    const response = await axiosInstance.post<{ data: CategoryResponse }>('/cms/v1/category', { name });
    return response.data.data.category;
  }

  /**
   * 更新分类
   * @param oldName 旧分类名称
   * @param newName 新分类名称
   * @returns 更新后的分类名称
   */
  static async updateCategory(oldName: string, newName: string): Promise<string> {
    const response = await axiosInstance.put<{ data: CategoryResponse }>(`/cms/v1/category/${oldName}`, { name: newName });
    return response.data.data.category;
  }

  /**
   * 删除分类
   * @param name 分类名称
   * @returns 删除的分类名称
   */
  static async deleteCategory(name: string): Promise<string> {
    const response = await axiosInstance.delete<{ data: CategoryResponse }>(`/cms/v1/category/${name}`);
    return response.data.data.category;
  }

  /**
   * 批量上传分类
   * @param categories 分类数据，支持数组格式 ["Category1", "Category2"] 或对象格式 {list: [...], stats: {...}}
   */
  static async bulkUploadCategories(categories: string[] | { list?: string[], stats?: Record<string, number> }): Promise<{
    total: number;
    successCount: number;
    failedCount: number;
    success: Array<{
      index?: number;
      name: string;
    }>;
    failed: Array<{
      index?: number;
      name?: string;
      error: string;
    }>;
  }> {
    const response = await axiosInstance.post('/cms/v1/category/bulk', JSON.stringify(categories), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data.data;
  }
}
